<div class="employers">
</div>
<div class="title-container-1">
  <div class="title-container-2">
    <div class="search-text">404</div>
  </div>
</div>
<div class="container-1">
  <div #containerRef class="container-2 scroll-fade">
    <div class="left apple-card">
      <div class="title">Pagina niet gevonden</div>
      <div class="information">
        <div>Sorry, we hebben de pagina niet kunnen vinden! Maak je echter niet druk, we gaan vanzelf terug naar de homepage.</div>
      </div>
      <div>
        <button class="apple-cta apple-cta--blue" (click)="navigateTo('home')">
          <span>We gaan vanzelf terug in <span class="countdown ml-1">{{countdown}}</span>s</span>
          <icon name="navigate_next"></icon>
        </button>
      </div>
    </div>
  </div>
</div>
